import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';

import EmailTemplateIcon from 'material-ui/svg-icons/content/drafts';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import * as Colors from 'material-ui/styles/colors';
import { statusColours } from '../../constants/ColourConstants';

import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

class EmailTemplateListItem extends Component {

    render() {

        const row = this.props.data;
        const infoLink = '/dashboard/email/template/' + row.id;
        const editLink = '/dashboard/email/template/' + row.id + '/edit';

        const actions = [

            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            {
                type:'divider'
            },
            {
                link: editLink,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    show: !!row.canEdit,
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete template',
                deleteAction: EmailTemplateActions.delete,
                message: (
                            <span>
                                Are you sure to delete this email template  "{row.name}" ?
                            </span>
                        ),
                condition: {
                    show:  !!row.canEdit && row.sysStatus > 4,
                    roles: [ROLES.ADMIN]
                }
            }
        ];

        const menuItems = buildContextMenu(actions, this.context.auth);
        const dateAdded = moment(row.dateAdded).fromNow();

        let summary     = row.name;
        let description = row.typeName;
        let statusLine  = 'Created ' + dateAdded;

        return (

            <ListItem
                key = {row.id.toString()}
                style={style.listItem}
                leftAvatar={
                    <Link to={infoLink}>
                        <EmailTemplateIcon
                            style={style.icon}
                            color={statusColours.primary}
                        />
                    </Link>
                }
                primaryText={
                    <Link to={infoLink} className="primaryText">
                    {summary}
                    </Link>
                }
                secondaryText={
                    <Link to={infoLink} className="secondaryText">
                    {description} <br />
                    <em>{statusLine}</em>
                    </Link>
                }
                secondaryTextLines={2}
                rightIcon={
                    <IconMenu
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton
                                touch={true}
                                style={style.iconButton}
                            >
                                <MoreVertIcon  color={Colors.grey400} />
                            </IconButton>
                        }
                    >{menuItems}

                    </IconMenu>
                }
            />
        )
    }
}

EmailTemplateListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default EmailTemplateListItem;
